export const environment = {
    api_domain: "https://fire-claim-view-api.claims.clmsbx.test.c1.statefarm/fire-claim-view/claims/",
    user_domain: "https://fire-claim-view-api.claims.clmsbx.test.c1.statefarm/fire-claim-view/user",
    secureLogin: "https://b2b-login-app-dev.digital.test.statefarm.com/UI/Login",
    contactUs: "https://forms-dev.b2b.test.statefarm.com/contact-us",
    fsptUrl: "https://fire-vendor-dev.b2b.test.statefarm.com/validate-claim"

}